import { convert } from "@/libs/units";
import type { DataSet, NumericPoint } from "@incytestudios/ddv";
import { isFinitePoint, isNaturalPoint } from "../_common";
import type { SinglePumpChartContext } from "..";

const getTargetNPSHRPoints = (
  context: SinglePumpChartContext,
  npshrPoints: NumericPoint[]
): NumericPoint[] => {
  const { baseXUnit, baseYUnit, targetXUnit, targetYUnit, liquidFlowRateSTBD } =
    context;
  return npshrPoints
    .map<NumericPoint>(point => {
      return {
        x: liquidFlowRateSTBD,
        y: point.y
      };
    })
    .map(pt => ({
      x: convert(pt.x, baseXUnit, targetXUnit),
      y: convert(pt.y, baseYUnit, targetYUnit)
    }))
    .filter(isFinitePoint)
    .filter(isNaturalPoint);
};

export const getDataSetTargetNPSHR = (
  context: SinglePumpChartContext,
  npshrPoints: NumericPoint[]
): DataSet => {
  const { targetXUnitLabel, targetYUnitLabel } = context;
  return {
    title: "Target NPSHr",
    xAxisLabel: `Flow Rate (${targetXUnitLabel})`,
    yAxisLabel: `Head (${targetYUnitLabel})`,
    points: getTargetNPSHRPoints(context, npshrPoints)
  };
};
